<div>
  <button
    class="collapsible"
    (click)="btnExpandTable_click($event)"
    [hidden]="this.storage.getSelectedLocation() == undefined"
  >
    Locations
  </button>
  <div
    id="merchantSearch"
    style="margin-bottom: 15px"
    [hidden]="merchant != undefined || hideTable"
  >
    <app-filterable-table
      #merchantTable
      [tableView]="merchantTableView"
      [options]="merchantTableOptions"
    ></app-filterable-table>
  </div>
</div>

@if (selectedMerchant != undefined) {
  <div>
    <div id="merchantDetails">
      <app-upcoming-statement></app-upcoming-statement>
      <app-merchant-details
        [merchant]="selectedMerchant"
      ></app-merchant-details>
    </div>
    <div [hidden]="storage.getSelectedTransaction() == undefined">
      <div style="margin-bottom: 20px">
        <app-transaction-details
          [transaction]="storage.getSelectedTransaction()"
        ></app-transaction-details>
      </div>
      <div>
        <input
          type="button"
          value="Close"
          class="button_primary button_var_2"
          (click)="btnCloseTransaction_click()"
        />
      </div>
    </div>
  </div>
}
